export default __webpack_public_path__ + "static/media/img_about-photos-m01.f4e6b680.jpg";